import styled from "styled-components";

export const LinkContainerStyled = styled.a`
  margin: 30px 32px 74px 0;
  align-self: flex-end;
  display: flex;
  align-items: center;
  text-decoration: none !important;
  padding: 8px 16px 8px 12px;
  border-radius: 20px;

  @media(min-width: 1920px){
    margin-bottom: 230px;
  }

  &:hover, &:focus {
    span {
      color: #0F59E6;
    }

    svg path {
      fill: #0F59E6;
    }
  }

  &:active {
    color: #0F59E6;
    background: #54B2FF29;
  }

  span {
    color: #343A40;
    font-weight: 450;
    padding-left: 6px;
    font-size: 16px;
  }

`;